import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import focusValues from "@/.sourceflow/about_us_focus_values.json";

export const useFocusValues = ({ limit } = {}) => {
  const collection = useSourceFlowCollection(focusValues);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useFocusValues;
